<template>
  <div class="calendar">
    <el-date-picker
      class="calendar"
      format="yyyy-MM-dd"
      v-model="date"
      type="date"
      :placeholder="$t('select_a_date')"
      :picker-options="datePickerOptions"
      @change="onDateSelect"
      value-format="yyyy-MM-dd"
    ></el-date-picker>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
  name: "calendar",
  data(){
    return {
    datePickerOptions: {
      disabledDate(date) {
        return date.getTime() < Date.now() - 8.64e7;
        }
      },
      date: '',
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations('navbar', ['validateRadiusHome']),
    onDateSelect(event) {
      this.$emit('clicked', this.date)
    },
  },
  watch: {},
  computed: mapState ({}),
}
</script>

<style lang="less">
@import "../assets/css/calendar.less";

</style>



// WEBPACK FOOTER //
// src/view/calendar.vue